const _ = require('core/src/utils/legacy');
const $ = require('jquery');
const { isjQuery } = require('client/src/utils/jquery');
const EventInterface = require('core/src/event-interface');
const Function = require('core/src/function');
const log = require('core/src/log').instance("client/ui/renderer");
const Icon = require('client/src/utils/icon').default;
const CodeEvaluator = require('core/src/code-evaluator');

/* Constructor */

const ViewRenderer = function(dependencies) {
	this._contextMenus = {};

	this._eventHandler = new EventInterface();
	this._eventHandler.extend(this);

	this._updateRequests = {};
	this._content = null;
	this.codeEvaluator = dependencies && dependencies.get(CodeEvaluator);
};
ViewRenderer.viewType = undefined;
ViewRenderer.mouse = {
	x: 0,
	y: 0
};

// Prevent browser context menu on context menu modal
$(document).on('contextmenu', '.context-menu', function(e){ return false; });
// Keep track of mouse (for context menu placement)
$(document).on('mousemove', function(e) {
	ViewRenderer.mouse.x = e.pageX;
	ViewRenderer.mouse.y = e.pageY;
});

$(document).on('click', '.togglePassword', function(){
	$(this).toggleClass('show');
	$(this).prev('input:first').attr('type', (_, attr) => attr === 'password' ? 'text' : 'password')
});

/* Statics */

ViewRenderer.Event = {
	TRIGGER: Function.Event.In.TRIGGER,
	TRIGGER_BY_ID: Function.Event.In.TRIGGER_BY_ID
};

/** @deprecated: use Event.TRIGGER instead. */
ViewRenderer.TRIGGER 		= ViewRenderer.Event.TRIGGER; // backward compatibility
/** @deprecated: use Event.TRIGGER instead. */
ViewRenderer.USER_EVENT 	= ViewRenderer.Event.TRIGGER; // backward compatiblity

/* Properties */

ViewRenderer.prototype._isClosed = false;
ViewRenderer.prototype._eventHandler = undefined;
ViewRenderer.prototype._contextMenus = undefined;
ViewRenderer.prototype._disableContextMenu = undefined;
ViewRenderer.prototype._listeners = undefined;
ViewRenderer.prototype._instanceID = undefined;
ViewRenderer.prototype._functionID = undefined;
ViewRenderer.prototype._title = undefined;
ViewRenderer.prototype._viewType = undefined;

/* Methods */

/**
 * For override. Render content.
 * @param {object} renderData
 * @returns {undefined}
 */
ViewRenderer.prototype.doRender = function(renderData) {
	return $('<div>');
};

/**
 * TODO: Make asynchronous, since many renderers use asynchronous libraries
 * Renders content.
 * @param {object} renderData
 * @returns {$}
 */
ViewRenderer.prototype.render = function(renderData) {
	renderData = renderData || {};

	this._title = _.get(renderData.input, 'name');
	// Use the trigger-compatible eval context when the View provides one (so (%)._function works in show/enable/condition); fall back to the raw input.
	this._contextMenuEventData = renderData.contextMenuEvalContext || renderData.input;

	var main = $('<div class="graphileon-viewrenderer">');
	var content = $('<div class="graphileon-viewrenderer-output">');
	main.append(content);

	var rendered = this.doRender(renderData.input);
	content.append(rendered);

	this._disableContextMenu = renderData.disableContextMenu;
	this.createContextMenus(renderData.contextMenus);
	this.renderContextMenus();
	this._content = main;
	this.renderToolbar(renderData.batchTriggers);

	return main;
};

ViewRenderer.prototype.updateCommon = function(updatedRenderData) {
	this._contextMenuEventData = updatedRenderData.contextMenuEvalContext || updatedRenderData.input || this._contextMenuEventData;
	this.createContextMenus(updatedRenderData.contextMenus);
	this.renderContextMenus();
	this.renderToolbar(updatedRenderData.batchTriggers);
};

ViewRenderer.prototype.createContextMenus = function(contextMenus) {
	this._contextMenus = {};
	this._contextMenuData = contextMenus;
	this.addContextMenus(contextMenus);
}

ViewRenderer.prototype.getContextMenuData = function() {
	return this._contextMenuData;
};

/**
 *
 * @param mutations
 * @param [executeTriggers]
 * @param [sendUpdateEvent]		Ask the Function to send an UpdateEvent, which will call this renderer's update method
 * @return {undefined}
 */
ViewRenderer.prototype.requestUpdate = function(mutations, executeTriggers = true) {
	let id = _.uniqueId('update-');

	return new Promise((resolve, reject) => {
		this._updateRequests[id] = {resolve, reject};

		this.event(Function.Event.In.UPDATE_MODEL, {
			mutations: mutations,
			executeTriggers: executeTriggers,
			updateID: id
		});
	});
};

ViewRenderer.prototype.getTitle = function() {
	return this._title || this._viewType;
};

ViewRenderer.prototype.setViewType = function(type) {
	this._viewType = type;
};

ViewRenderer.prototype.setContainerState = function(property, value) {
	this.requestUpdate({
		container: {
			[property]: value
		}
	}, true);
};

/**
 * For override. Called in update.
 * @param {object} data	 The update data.
 */
ViewRenderer.prototype.doUpdate = function(data, changes, updateID) {
	log.warn("This ViewRenderer has not implemented doUpdate.");
	return true;
};

/**
 * Updates the ViewRenderer with the given data. Calls doUpdate for specific update procedures of subclasses.
 * @param {object} model				 The update data.
 * @param {object} changes
 * @param {object} updateID
 */
ViewRenderer.prototype.update = function(model, changes, updateID) {
	this._title = _.get(model, 'name');

	let updated = false;

	// If there are changes to the model, call renderer's doUpdate
	if(Object.keys(changes).length > 0) {
		this._disableContextMenu = model.disableContextMenu;
		let updated = this.doUpdate(model, changes, updateID);
		if(updated === false) {
			log.warn("Update failed.");
			return false;
		}
	} else {
		log.log("No changes to model. Not re-rendering.");
	}

	// Resolve the update request
	if(updateID in this._updateRequests) {
		this._updateRequests[updateID].resolve({model, changes});
		delete this._updateRequests[updateID];
	}

	return updated;
};

/**
 * Fire event.
 * @param {string} event
 * @param {object} data
 * @returns {undefined}
 */
ViewRenderer.prototype.event = function(event, data) {
	data = _.parsePrimitiveValues(data);
	return this.fire(event, data);
};

/**
 * For override. Finalizes the rendering when its container is ready.
 * @returns {boolean|undefined}
 */
ViewRenderer.prototype.onReady = function() {
	return true;
};

/**
 * Calls the onReady function of the viewrenderer.
 * @returns {undefined}
 */
ViewRenderer.prototype.ready = function() {
	this.onReady();
	// TODO: Should be different type of event (when more types are added and processed by ViewManager and FTI)
	this.trigger({
		type: 'load'
	});
};

/**
 * For override.
 * @returns {boolean}
 */
ViewRenderer.prototype.onClose = function() {
	return true;
};

/**
 * Closes the ViewRenderer and notifies the listeners.
 * @param {string} origin	The origin of the close event.
 */
ViewRenderer.prototype.close = function(origin) {
	if(!this._isClosed) {
		this._isClosed = true;
		this.event(Function.Event.In.CLOSE, origin);
		this.onClose();
		this.removeListeners();

		this.breakDownUI();
	}
};

ViewRenderer.prototype.breakDownUI = function () {
	_.forEach(this._contextMenus, function(menu) {
		menu.close(true);
	});
	this._contextMenus = null;
};

/**
 * Adds a context menu item.
 * @param {string} menu The name of the menu.
 * @param {string} group The name of the group within the menu. Undefined for default.
 * @param {string} action The (human-readable) action to display on the item.
 * @param {function} callback A function that takes the target object as an argument.
 * @returns {undefined}
 */
ViewRenderer.prototype.addContextMenuItem = function(menu, group, action, callback, enable, show) {
	if(!(this._contextMenus[menu] instanceof ViewRenderer.ContextMenu)) {
		this._contextMenus[menu] = new ViewRenderer.ContextMenu(menu);
	}
	var menuObj = this._contextMenus[menu];
	menuObj.addItem(group, action, callback, enable, show);
};

/**
 * Evaluates a context menu show/condition/enable expression against the event data available when the menu opens.
 * @param {*} condition Boolean value or expression string.
 * @param {object} target Event data exposed as (%) during evaluation.
 * @returns {boolean}
 */
ViewRenderer.prototype.evaluateContextMenuCondition = function(condition, eventData) {
	if(_.isNil(condition) || condition === '') {
		return true;
	}

	if (!_.isString(condition)) {
		return !!condition;
	}

	if (!(this.codeEvaluator instanceof CodeEvaluator)) {
		log.warn("No CodeEvaluator registered for context menu condition. Cannot evaluate code.");
		return true;
	}

	let code = CodeEvaluator.replaceCodePlaceholders(condition.trim(), {
		'(%)': '_event',
		'(@)': '_global'
	});

	try {
		return !!this.codeEvaluator.evaluate('var x = ' + code, {
			_event: eventData,
			_global: _.get(eventData, '_global', {})
		}, {
			arrayExpressions: true,
			expressionSet: 'full'
		})['x'];
	}
	catch (e) {
		log.warn("Could not evaluate context menu condition.", condition, e);
		return false;
	}
};

/**
 * Checks whether a context menu item should be shown for the clicked target.
 * @param {object} item Context menu item definition.
 * @param {object} target Object the context menu was opened for.
 * @returns {boolean}
 */
ViewRenderer.prototype.isContextMenuItemVisible = function(item, target) {
	// Keep (%) compatible with normal trigger data while adding the clicked context-menu target.
	let eventData = _.extend({}, this._contextMenuEventData, {target});

	return this.evaluateContextMenuCondition(item.show, eventData)
		&& this.evaluateContextMenuCondition(item.condition, eventData);
};

/**
 * Checks whether a context menu item should be enabled for the clicked target.
 * @param {object} item Context menu item definition.
 * @param {object} target Object the context menu was opened for.
 * @returns {boolean}
 */
ViewRenderer.prototype.isContextMenuItemEnabled = function(item, target) {
	// Enable expressions can depend on both the current view input and the clicked target.
	return this.evaluateContextMenuCondition(item.enable, _.extend({}, this._contextMenuEventData, {target}));
};

ViewRenderer.prototype.addContextMenus = function(menus) {
	if(!_.isObject(menus)) {
		return;
	}
	var self = this;

	_.forEach(menus, function(items, menu) {
		_.forEach(items, function(item) {
			if(_.isObject(item)) {
				self.addContextMenuItem(menu, item.index, item.action, function(target) {
					self.triggerContextMenuItem(item, target);
				}, function(target) {
					return self.isContextMenuItemEnabled(item, target);
				}, function(target) {
					return self.isContextMenuItemVisible(item, target);
				});
			} else {
				log.warn("Invalid context menu item.", item);
			}
		});
	});
};

ViewRenderer.prototype.triggerContextMenuItem = function(item, target) {
	this.triggerById(item.id, {
		type: 'context',
		...item,
		target
	});
};

/**
 * Renders the context menus and appends them to the given element.
 * @returns {undefined}
 */
ViewRenderer.prototype.renderContextMenus = function() {
	// Close all current context menus
	_.forEach(this._contextMenus, menu => {
		menu.close();
	});

	for(var i in this._contextMenus) {
		this._contextMenus[i].render();
	}
};

/**
 * Get a context menu by name.
 * @param {string} menu
 * @returns {undefined}
 */
ViewRenderer.prototype.getContextMenu = function(menu) {
	return this._contextMenus[menu];
};

/**
 * Opens the specified context menu, if available.
 * @param {string} menu
 * @param {object} target
 * @param {Number} x If undefined, takes the current mouse X-coordinate on page.
 * @param {Number} y If undefined, takes the current mouse Y-coordinate on page.
 * @returns {Boolean} True if the context menu was available, false if not.
 */
ViewRenderer.prototype.openContextMenu = function(menu, target, x, y) {
	if(_.get(this._disableContextMenu, menu)) return false;

	if(x === undefined) {
		x = ViewRenderer.mouse.x;
	}
	if(y === undefined) {
		y = ViewRenderer.mouse.y;
	}
	if(this._contextMenus[menu] instanceof ViewRenderer.ContextMenu) {
		this._contextMenus[menu].open(target, x, y);
		return true;
	}
	return false;
};

/**
 * Closes the specified context menu, if available and open.
 * @param {string} menu
 * @returns {Boolean} True if the context menu was available and open.
 */
ViewRenderer.prototype.closeContextMenu = function(menu) {
	if(this._contextMenus[menu] instanceof ViewRenderer.ContextMenu) {
		this._contextMenus[menu].close();
		return true;
	}
	return false;
};

/**
 * Renders the toolbar adding buttons for each batch trigger.
 * @param {jQuery} toolbar
 * @param {object} batchTriggers
 * @returns {undefined}
 */
ViewRenderer.prototype.renderToolbar = function(batchTriggers) {
	if (this._toolbar) {
		this._toolbar.remove();
	}

	if(! _.size(batchTriggers)) {
		this._toolbar = null;
		return;
	}

	// Render toolbar
	this._toolbar = $('<div>').addClass('toolbar');
	this.createBatchTriggerButtons(this._toolbar, batchTriggers);
	this._content.prepend(this._toolbar);
};

/**
 * Renders buttons at the top of the View that fire 'batch' triggers.
 * @param {jQuery} toolbar			The element to which to add the batch triggers.
 * @param {array} batchTriggers		Batch triggers definitions.
 */
ViewRenderer.prototype.createBatchTriggerButtons = function(toolbar, batchTriggers) {
	let self = this;

	if(_.isArray(batchTriggers)) {
		let triggers = batchTriggers.sort(function(a, b) {
			return _.compareIndex(a.index, b.index);
		});

		for(let i in triggers) {
			let trigger = triggers[i];
			let $button = $('<button>', {
				class: 'batch-action btn btn-secondary btn-sm m-1 ms-0 border-0'
			});
			$button.attr('action', trigger.action);

			// Set the button caption
			let caption = trigger.action;

			// If name is specified use that instead of action as the caption
			if (! _.isEmpty(trigger.name)) {
				caption = trigger.name;
			}

			// If icon is specified set it
			let $icon = '';
			if (! _.isEmpty(trigger.icon)) {
				$icon = $('<i>')
					.addClass(Icon.getClass(trigger.icon))

				if (caption.length > 0)
					$icon.addClass('me-2');
				$button.prepend($icon);
			}

			$button.append(caption);

			// Set Tooltip
			if (trigger.tooltip){
				$button.attr('data-bs-html', true);
				$button.attr('data-bs-toggle', "tooltip");
				$button.attr('data-bs-placement', "top");
				$button.attr('data-bs-trigger', "hover");
				$button.attr('data-bs-title', trigger.tooltip);
				$button.attr('title', trigger.tooltip);
			}

			// Check if its disabled
			if (_.isBoolean(trigger.enable) && !trigger.enable){
				$button.prop('disabled', true);
			} else {
				// Set style if not disabled
				if(_.isNil(trigger.enable) || trigger.enable) $button.attr('style', trigger.style);
			}

			// Switch style and hover style on hover
			function hoverCallback(button, trigger) {
				return () => button.attr('style', trigger.hoverStyle);
			}
			function hoverOutCallback(button, trigger) {
				return () => button.attr('style', trigger.style);
			}

			$button.hover(hoverCallback($button, trigger), hoverOutCallback($button, trigger));

			(function(trigger){
				$button.on('click', function(){
					self._batchAction(trigger);
				});
			})(trigger);
			toolbar.append($button);
		}
	}
};

/**
 * For override. Should resize the renderered content.
 * @returns {Boolean}
 */
ViewRenderer.prototype.doResize = function(width, height) {
	return true;
};

/**
 * Resizes the rendered content.
 * @returns {Boolean}
 */
ViewRenderer.prototype.resize = function(width, height) {
	return this.doResize(width, height);
};

/**
 * Fire an event that executes triggers from the View.
 * @param data
 */
ViewRenderer.prototype.trigger = function(data) {
	this.event(ViewRenderer.Event.TRIGGER, _.cloneDeep(data));
};

ViewRenderer.prototype.triggerById = function(id, data) {
	this.event(ViewRenderer.Event.TRIGGER_BY_ID, {id, data: _.cloneDeep(data)});
};

/**
 * @deprecated: use .trigger instead
 *
 * Fire Trigger event from renderer
 * @param {object} data
 * @returns {undefined}
 */
ViewRenderer.prototype.userEvent = function(data) {
	this.trigger(data);
};

/**
 * Set the instanceID of the View this ViewRenderer represents.
 * @param instanceID
 * @returns {undefined}
 */
ViewRenderer.prototype.setInstanceID = function(instanceID) {
	this._instanceID = instanceID;
};

/**
 * Set the functionID of the View Function this ViewRenderer represents an instance of.
 * @param functionID
 */
ViewRenderer.prototype.setFunctionID = function(functionID) {
	this._functionID = functionID;
};

/**
 * Get the ID of the Function this ViewRenderer represents an instance of.
 * @returns {undefined|*}
 */
ViewRenderer.prototype.getFunctionID = function() {
	return this._functionID;
};

/**
 * Get the instanceID of the View this ViewRenderer represents.
 * @returns {string}
 */
ViewRenderer.prototype.getInstanceID = function() {
	return this._instanceID;
};

/**
 * Checks if a given path string is present in a changes object, either as an
 * exact key or as a prefix to a key (indicating a change in a nested property).
 * This function is curried.
 *
 * @function
 * @param {object} changesObj - The object containing changed paths as keys.
 * @param {string} pathStr - The path string to check for (e.g., 'prop.nestedProp').
 * @returns {boolean} - True if the path or a sub-path has changed.
 */
ViewRenderer.prototype.hasChangedIn = _.curry((changesObj, pathStr) => {
  // Use _.keys to get all property paths from the changes object.
  const changedPaths = _.keys(changesObj);

  // Use _.some to check if any path meets the criteria.
  // A path is considered a match if it's either an exact match for pathStr,
  // or if it's a sub-path (e.g., it starts with 'pathStr.').
  return _.has(changesObj, pathStr) || _.some(
    changedPaths,
    (p) => _.startsWith(p, `${pathStr}.`)
  );
});

/**
 * Fires the trigger of the batch action specified.
 * @param {object} trigger	Batch trigger object
 * @returns {undefined}
 */
ViewRenderer.prototype._batchAction = function(trigger) {
	if(!_.isObject(trigger)) {
		log.error("Invalid batch trigger. Could not execute.");
		return;
	}

	let event = {};

	// For backwards compatibility with NetworkView and TableView
	if(_.isFunction(this.getBatchSelection)) {
		event.selection = this.getBatchSelection();
	}

	this.triggerById(trigger.id, event);
};

/**************** CONTEXT MENU CLASS ********************/

/**
 *
 * @param {string} name
 * @constructor
 */
ViewRenderer.ContextMenu = function(name) {
	this.name = name;
	this.items = {};
	this.target = null;
};

/* Statics */
ViewRenderer.ContextMenu.GROUP_DEFAULT = 'default';

/* Properties */

ViewRenderer.ContextMenu.prototype.name = undefined;
ViewRenderer.ContextMenu.prototype.items = undefined;
ViewRenderer.ContextMenu.prototype.target = undefined;
ViewRenderer.ContextMenu.prototype.element = undefined;
ViewRenderer.ContextMenu.prototype.modal = undefined;

/* Methods */

ViewRenderer.ContextMenu.prototype.getItem = function(group, label) {
	return this.items[group][label];
};

/**
 *
 * @param group	 The name of the group in which this item will be displayed. Can be used as ordering index.
 * @param label
 * @param callback
 * @returns {ViewRenderer.ContextMenu.Item}
 */
ViewRenderer.ContextMenu.prototype.addItem = function(group, label, callback, enable, show) {
	var self = this;

	var check = _.validate({
		label: [label, "isString"],
		group: [group, _.isStringOrNumber(group), {default: ViewRenderer.ContextMenu.GROUP_DEFAULT, warn: group !== undefined}]
	}, "Could not add context item.");
	if(!check.isValid()) return null;
	const valid = check.getValue();

	// Create an Item
	var item = new ViewRenderer.ContextMenu.Item(valid.label, callback, enable, show);
	item.element.on('click', function(){
		if (!item.isEnabled(self.target)) return;
		item.callback(self.target);
	});

	// Register item
	if(!_.isObject(this.items[valid.group])) {
		this.items[valid.group] = {};
	}
	this.items[valid.group][valid.label] = item;

	return item;
};

/**
 * Displays the context menu with a given target as its subject.
 * @param {object} target
 * @returns {undefined|boolean}
 */
ViewRenderer.ContextMenu.prototype.open = function(target, x, y) {
	if(!isjQuery(this.element)) {
		log.warn("Context menu '" + this.name + "' has not been (properly) rendered yet.");
		return false;
	}

	var self = this;

	if(x === undefined) {
		x = 0;
	}
	if(y === undefined) {
		y = 0;
	}

	this.element.css({
		left: x + 'px',
		top: y + 'px',
		position: 'absolute',
		'z-index': 99999
	});

	var closeMenuOnClick = function(ev) {
		// Close only on left click. Firefox triggers click event for rightclicks too.
		if (ev.button !== 0 || ev.target.classList.value.includes('disabled')) return;
		$(document).off('click', closeMenuOnClick);
		self.close();
	};

	$(document).on('click', closeMenuOnClick);

	$(document).trigger('graphileon-context-menu-open');
	$(document).one('graphileon-context-menu-open', function() {
		self.close();
	});

	this.target = target;
	// Show/enable rules are target-dependent, so refresh item state every time the menu opens.
	this.updateVisibleItems(target);
	$('body').append(this.element);
};

/**
 * Recomputes visibility and enabled state for all items using the current target.
 * @param {object} target Object the context menu was opened for.
 * @returns {undefined}
 */
ViewRenderer.ContextMenu.prototype.updateVisibleItems = function(target) {
	_.forOwn(this.items, function(group) {
		_.forOwn(group, function(item) {
			item.setVisible(item.isVisible(target));
			item.setEnabled(item.isEnabled(target));
		});
	});
};

/**
 * Hides the context menu.
 * @param {boolean} [permanent]		If true, the context menu will be destroyed.
 * @returns {undefined|boolean}
 */
ViewRenderer.ContextMenu.prototype.close = function(permanent) {
	if(!isjQuery(this.element)) {
		return false; // nothing to close
	}
	this.target = null;
	if(permanent === true) {
		this.element.remove();
	} else {
		this.element.detach();
	}
};

ViewRenderer.ContextMenu.prototype.render = function() {
	var element = $('<ul>');
	element.addClass('context-menu');
	element.addClass('context-menu-' + this.name);
	element.addClass('list-group');
	element.css('position', 'absolute');

	element.empty();

	var groups = Object.keys(this.items).sort(_.compareIndex);

	// Add all the items to the menu
	for(var i in groups) {
		var group = groups[i];
		for(var action in this.items[group]) {
			element.append(this.items[group][action].element);
		}
	}

	this.element = element;
	return element;
};

/* CONTEXT MENU ITEM CLASS */

ViewRenderer.ContextMenu.Item = function(label, callback, enable = true, show) {
	this.label = label;
	this.enable = enable;
	this.show = show;
	this.callback = callback;
	this.element = this.render();
};

/* Properties */

ViewRenderer.ContextMenu.Item.prototype.label = undefined;
ViewRenderer.ContextMenu.Item.prototype.callback = undefined;
ViewRenderer.ContextMenu.Item.prototype.element = undefined;
ViewRenderer.ContextMenu.Item.prototype.enable = undefined;
ViewRenderer.ContextMenu.Item.prototype.show = undefined;

/* Methods */

ViewRenderer.ContextMenu.Item.prototype.render = function() {
	var element = $('<li>');
	element.addClass('context-menu-item');
	element.addClass('list-group-item');
	element.html(this.label);
	return element;
};

/**
 * Resolves whether this item is enabled for the current target.
 * @param {object} target Object the context menu was opened for.
 * @returns {boolean}
 */
ViewRenderer.ContextMenu.Item.prototype.isEnabled = function(target) {
	// Enable may be a precomputed boolean or a runtime evaluator supplied by the renderer.
	if (_.isFunction(this.enable)) {
		return this.enable(target);
	}

	return this.enable !== false;
};

/**
 * Resolves whether this item is visible for the current target.
 * @param {object} target Object the context menu was opened for.
 * @returns {boolean}
 */
ViewRenderer.ContextMenu.Item.prototype.isVisible = function(target) {
	// Visibility may be static or target-dependent through show/condition expressions.
	if (_.isFunction(this.show)) {
		return this.show(target);
	}

	return this.show !== false;
};

/**
 * Applies the visibility state to the item element.
 * @param {boolean} visible
 * @returns {undefined}
 */
ViewRenderer.ContextMenu.Item.prototype.setVisible = function(visible) {
	this.element.toggle(visible !== false);
};

/**
 * Applies the enabled state to the item element.
 * @param {boolean} enabled
 * @returns {undefined}
 */
ViewRenderer.ContextMenu.Item.prototype.setEnabled = function(enabled) {
	this.element.toggleClass('disabled', enabled === false);
};

module.exports = ViewRenderer;
